"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrearsDecisionTypeCode = void 0;
var dre_1 = require("../dre");
exports.ArrearsDecisionTypeCode = (_a = {},
    _a[dre_1.DecisionTypeCode.Pass] = dre_1.DecisionTypeCode.Pass,
    _a[dre_1.DecisionTypeCode.Fail] = dre_1.DecisionTypeCode.Fail,
    _a);
